import {nonBlank} from "../../libs/utils/epic.utils";

export class NumberConfigDto {

  public id: string | null = null;

  public type!: string;

  public name!: string;

  public pattern!: string;

  public initial!: number;

  public currentCounter!: number;

  public changeable: boolean | undefined;

  public collisionFree!: boolean;

  public numberExamples!: string[];

  public nextNumber!: string;

  public allowChange!: boolean;

  constructor(init?: Partial<NumberConfigDto> | undefined) {
    Object.assign(this, init);
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public set(key: string, value: any): void {
    // @ts-ignore
    this[key] = value;
  }

  public update(config: NumberConfigDto): void {
    this.collisionFree = config.collisionFree;
    if (config.numberExamples && config.numberExamples.length > 0) {
      this.numberExamples = config.numberExamples;
    }
    if (nonBlank(config.pattern)) {
      this.pattern = config.pattern;
    }
  }
}
